/*
* @描述: 订单列表
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/12 16:59
*/
<template>
    <PullContainer ref="pullContainerRef" :pullDownLabel="true" :pullDownLoading="false">
        <template #container>
            <div v-loading="loading" class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="true" :isTitleNormal="true" title="返回"></ReturnNavBar>
                    <span class="handle_icon_wrap" @click="handleClickAddInvoice">
                        <i class="iconfont icon-a-tianjiamiaobian"></i>
                    </span>
                </div>
                <div class="top_search">
                    <van-search v-model="searchForm.keyword"
                                placeholder="请输入查询内容"
                                @clear="onSearch"
                                @search="onSearch">
                        <template #right-icon>
                            <i class="iconfont icon-shaixuan" @click="handleClickAdvancedFilter"></i>
                        </template>
                    </van-search>
                </div>
                <div class="mobile_container">
                    <ul v-infinite-scroll="scrollLoadList" class="invoice_list">
                        <li v-for="(row, index) in invoiceList" :key="index" class="invoice_item">
                            <div class="invoice_item_header">
                                <div class="flex_wrap">
                                    <div class="receivable_no_wrap" @click="handleClickInvoiceDetail(row)"
                                         v-text="row.invoice_no"></div>
                                    <span :class="'invoice_status_name_'+row.status" class="status_name"
                                          v-text="row.status_name"></span>
                                    <span v-if="row.status===3||row.status===4"
                                          class="handle_icon_wrap"
                                          @click="handleClickShowReason(row)">
                                        <i class="iconfont icon-jinggao"></i>
                                    </span>
                                </div>
                                <span v-if="row.status===1&&row.uid===userInfo.user.id"
                                      class="handle_icon_wrap"
                                      @click="handleClickInvoiceRevoke(row)">
                                    <i class="iconfont icon-chexiao"></i>
                                </span>
                                <span v-else-if="row.status===3||row.status===4||row.status===5"
                                      class="handle_icon_wrap"
                                      @click="handleClickInvoiceAgain(row)">
                                    <i class="iconfont icon-zaicitijiao"></i>
                                </span>
                            </div>
                            <div class="invoice_item_content">
                                <div class="flex_wrap">
                                    <span class="field_label">开票公司：</span>
                                    <span class="field_value" v-text="row.invoice_company_name"></span>
                                </div>
                                <div class="flex_wrap">
                                    <span class="field_label">申请人：</span>
                                    <div class="custom_contact_field_wrap">
                                        <PersonnelCard v-if="row.apply_user_info" :userId="row.uid">
                                            <template slot="container">
                                                <img :src="row.apply_user_info.avatar || defaultImg" alt=""
                                                     class="avatar">
                                                <span class="name" v-text="row.apply_user_info.name"></span>
                                            </template>
                                        </PersonnelCard>
                                    </div>
                                </div>
                                <div class="flex_wrap">
                                    <span class="field_label">开票金额：</span>
                                    <span class="field_value" v-text="row.invoice_amount"></span>
                                </div>
                                <div class="flex_wrap">
                                    <span class="field_label">开票日期：</span>
                                    <span class="field_value" v-text="row.apply_time"></span>
                                </div>
                            </div>
                        </li>
                        <li v-if="invoiceList.length >= pagination.total" class="ta_c">--已经到底了--</li>
                    </ul>
                </div>
                <FooterTabbar :tabBarActive="tabBarActive" :tabBarList="tabBarList"></FooterTabbar>
                <InvoiceAddDialog v-if="invoiceDialogVisible"
                                  :dialogVisible.sync="invoiceDialogVisible"
                                  :invoice_no.sync="invoice_no"
                                  :source="'list'"
                                  @refresh="onSearch"/>
                <InvoiceDetailsDialog v-if="invoiceDetailsDialogVisible"
                                      :dialogVisible.sync="invoiceDetailsDialogVisible"
                                      :invoice_no.sync="invoice_no"/>
            </div>
        </template>
    </PullContainer>
</template>
<script>
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import InvoiceAddDialog from "./component/invoice_add"
import InvoiceDetailsDialog from "./component/invoice_detail";
import {mapState} from "vuex";
import {pagination} from "@/mixins";
import {orderInvoiceRecordCancel, orderInvoiceSummary} from "@/api";

export default {
    name: "InvoiceList",
    data() {
        return {
            loading: false,
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "Order",
                    title: "首页",
                },
                {
                    icon: "icon-a-dingdan1",
                    activeIcon: "icon-a-dingdan26",
                    routerName: "OrderList",
                    title: "订单",
                },
                {
                    icon: "icon-tuikuan",
                    activeIcon: "icon-tuikuan1",
                    routerName: "PaymentList",
                    title: "回款",
                },
                {
                    icon: "icon-fapiao",
                    activeIcon: "icon-a-fapiao1",
                    routerName: "InvoiceList",
                    title: "开票",
                },
            ],
            tabBarActive: 3,
            searchForm: {
                keyword: '',
                status: '',
                apply_time: '',
                invoice_type: '',
            },
            defaultImg: require('@/assets/images/default.jpg'),
            invoiceList: [],
            invoiceDialogVisible: false,
            invoice_no: '',
            invoiceDetailsDialogVisible:false,
        }
    },
    mixins: [pagination],
    components: {
        PersonnelCard,
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
        InvoiceAddDialog,
        InvoiceDetailsDialog,
    },
    created() {
        this.getOrderInvoiceList()
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    mounted() {

    },
    methods: {
        handleClickAddInvoice() {
            this.invoiceDialogVisible = true
        },

        onSearch() {
            this.pagination.pageNum = 1
            this.invoiceList = []
            this.getOrderInvoiceList()
        },

        handleClickAdvancedFilter() {

        },

        scrollLoadList() {
            if (this.invoiceList.length < this.pagination.total) {
                this.pagination.pageNum++
                this.getOrderInvoiceList()
            }
        },

        //获取开票汇总列表
        getOrderInvoiceList() {
            this.loading = true
            orderInvoiceSummary({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
                status: this.searchForm.status,
                apply_time: this.searchForm.apply_time,
                invoice_type: this.searchForm.invoice_type,
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.invoiceList = this.invoiceList.concat(data)
                    this.pagination.total = total
                }
                this.loading = false;
            })
        },

        //点击开票详情
        handleClickInvoiceDetail(row) {
            this.invoice_no = row.invoice_no
            this.invoiceDetailsDialogVisible = true
        },

        //点击弹出原因
        handleClickShowReason(row) {
            const reason = row.status === 3 ? row.reject_reason : row.invalid_reason
            this.$dialog.alert({
                title: row.status === 3 ? '驳回原因' : '作废原因',
                message: reason,
                confirmButtonColor: '#2990ff'
            }).then(() => {
                return false
            }).catch(() => {
                return false
            })
        },

        //点击重新发起开票申请
        handleClickInvoiceAgain(row) {
            this.invoice_no = row.invoice_no
            this.invoiceDialogVisible = true
        },

        //点击撤销开票申请
        handleClickInvoiceRevoke(row) {
            this.$dialog.confirm({
                title: '确定撤销当前开票记录？',
                message: '撤销后不可恢复，请谨慎操作！',
                confirmButtonColor: '#2990ff'
            }).then(() => {
                orderInvoiceRecordCancel({
                    invoice_no: row.invoice_no
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('撤销成功！')
                        this.getOrderInvoiceList()
                    }
                })
            }).catch(() => {
                return false
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.mobile_container {
    overflow-y: hidden;
    padding-top: 10px;

    .invoice_list {
        width: 100%;
        height: 100%;
        overflow-y: auto;

        .invoice_item {
            margin-bottom: 4px;
            background: #FFFFFF;
            padding: 10px 16px 2px;

            .invoice_item_header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 8px;
                border-bottom: 1px solid #E8E8E8;
                padding-bottom: 8px;

                .receivable_no_wrap {
                    font-size: 14px;
                    font-weight: 700;
                    line-height: 22px;
                    color: #2990FF;
                }

                .status_name {
                    color: #666666;
                    vertical-align: middle;
                    margin-left: 4px;

                    &::before {
                        content: '';
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                        display: inline-block;
                        vertical-align: middle;
                        margin-right: 4px;
                    }

                    &.invoice_status_name_1::before {
                        background: #F0AA32;
                    }

                    &.invoice_status_name_2::before {
                        background: #5AB333;
                    }

                    &.invoice_status_name_3::before {
                        background: #BFBFBF;
                    }

                    &.invoice_status_name_4::before {
                        background: #E44144;
                    }
                }
            }

            .invoice_item_content {
                padding-top: 10px;

                .flex_wrap {
                    line-height: 22px;
                    margin-bottom: 8px;
                }

                .field_label {
                    color: #999999;
                }

                .field_value {
                    color: #333333;
                }
            }
        }
    }
}
</style>